import { Icon } from "@iconify/react/dist/iconify.js";
import ServiceNav from "../constants/services-nav";
import { Link } from "react-router-dom";
import scrollToTop from "./scroll-to-top";

const IndividualServices = ({
  title,
  price,
  intro,
  included,
  excluded,
  base,
  precta,
  img,
  backto,
}) => {
  return (
    <>
      <div className="individual-service-page-container">
        <ServiceNav />
        <div className="individual-service-container">
          {img && (
            <img
              src={img}
              alt="hexagons"
              className="individual-service-hexagons"
            />
          )}

          <div className="service-intro">
            <h1>
              {title} <span>{price}</span>
            </h1>
            <p>{intro}</p>
          </div>
          <div className="features">
            <h5>What this plan includes:</h5>
            <ul className="feature-container">
              {included.map((included, index) => (
                <li className="inc-feature" key={index}>
                  <Icon icon="charm:circle-tick" className="icon" />{" "}
                  <span>{included}</span>
                </li>
              ))}{" "}
              {excluded.map((excluded, index) => (
                <li className="exc-feature" key={index}>
                  <Icon
                    icon="system-uicons:cross-circle"
                    className="icon"
                    strokeWidth="2"
                  />
                  <span>{excluded}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="service-outro">
            <p>{precta}</p>
            <div className="btns-container">
              <Link
                to="/booking"
                onClick={() => {
                  scrollToTop();
                }}
              >
                {" "}
                <button>
                  Sounds great, sign me up
                  <Icon
                    icon="qlementine-icons:calendar-16"
                    className="btn-icon"
                  />
                </button>{" "}
              </Link>
              <Link to={base}>
                {" "}
                <button
                  className="back-btn"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Back to {backto}
                  <Icon icon="akar-icons:arrow-back" className="btn-icon" />
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndividualServices;
